import { cn } from '@/lib/utils'

type UrgencyLevel = 'green' | 'amber' | 'red'

function getUrgencyLevel(daysRemaining: number): UrgencyLevel {
  if (daysRemaining > 21) return 'green'
  if (daysRemaining >= 14) return 'amber'
  return 'red'
}

// Center of each third of the pill — green | amber | red, left to right.
const MARKER_POSITION: Record<UrgencyLevel, string> = {
  green: 'left-[16.67%]',
  amber: 'left-1/2',
  red: 'left-[83.33%]',
}

const MARKER_COLOR: Record<UrgencyLevel, string> = {
  green: 'border-t-(--green)',
  amber: 'border-t-(--amber)',
  red: 'border-t-(--red)',
}

/** Small green/amber/red gauge with a pointer over the current third — used next to the policy-expiration countdown. */
export function UrgencyIndicator({ daysRemaining }: { daysRemaining: number }) {
  const level = getUrgencyLevel(daysRemaining)

  return (
    <span className="relative inline-flex h-3 w-8 shrink-0 items-end" aria-hidden="true">
      <span
        className={cn(
          'absolute -top-1 size-0 -translate-x-1/2 border-x-4 border-t-4 border-x-transparent',
          MARKER_POSITION[level],
          MARKER_COLOR[level]
        )}
      />
      <span className="flex h-2 w-full overflow-hidden rounded-full">
        <span className="h-full flex-1 bg-(--green)" />
        <span className="h-full flex-1 bg-(--amber)" />
        <span className="h-full flex-1 bg-(--red)" />
      </span>
    </span>
  )
}
